<template>
  <v-container fluid>
    <div id="app ">
      <div style="display: flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :items-per-page="6"
      :mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="400px">
            <template v-slot:activator="{ on, attrs }">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="50"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class=""
                    fab
                    small
                    color="#0C479D"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon class="icon-white">icon-download</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-divider></v-divider>

                  <v-list>
                    <v-list-item>
                      <v-list-item-action>
                        <vue-json-to-csv
                          :json-data="dataDownload"
                          :csv-title="'Topic Data'"
                        >
                          <v-btn color="indigo" dark style="">
                            CSV
                          </v-btn>
                        </vue-json-to-csv>
                      </v-list-item-action>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-action>
                        <v-btn @click="createPDF" color="indigo" dark
                          >PDF
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              <v-btn
                class="mr-2 ml-4"
                small
                fab
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
                @click="createRecord"
              >
                <v-icon class="icon-white">icon-add</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="background-blue">
                <span class="text-h5 icon-white">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container id="container">
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        :items="inputData.items"
                        v-model="inputData.selectedId"
                        :prepend-icon="inputData.icon"
                        :label="inputData.label"
                        :item-text="inputData.itemText"
                        :item-value="inputData.itemValue"
                        dense
                        v-if="!isedit"
                      ></v-autocomplete>
                      <div style="display:flex">
                        <DateTimeSelector
                          @datesSelected="onDatesSelected"
                          :params="paramFrom"
                          v-if="!isedit"
                        />
                        <DateTimeSelector
                          @datesSelected="onDatesSelected"
                          :params="paramTo"
                          v-if="isedit"
                        />
                      </div>
                      <v-form @submit.prevent="submitForm" id="form">
                        <v-textarea
                          label="Reason"
                          v-model="reason"
                          :rules="[(v) => !!v || 'Reason is required']"
                          v-if="!isedit"
                        ></v-textarea>
                        <br />
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn rounded color="#FE000C" @click="close">
                  <v-icon left class="icon-white">icon-cancel</v-icon>
                  <span style="color:white">Cancel</span>
                </v-btn>
                <v-btn rounded color="primary" @click="ITadminAccessDataEntry">
                  <v-icon left>icon-availability</v-icon>
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          v-if="item.end_date == undefined || null"
        >
          icon-action
        </v-icon>
      </template>
      <template v-slot:item.enable_status="{ item }">
        <v-switch
          color="indigo"
          @change="changeStatus(item, item.enable_status)"
          false-value="N"
          true-value="Y"
          v-model="item.enable_status"
        ></v-switch>
      </template>
      <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="setGridData"> Reset </v-btn>
        </template> -->
    </v-data-table>
    <div id="sucessAlert">
      <v-alert outlined type="success" text> Data Saved successfully. </v-alert>
    </div>
    <div id="errorAlert">
      <v-alert outlined type="warning" prominent border="left">
        Error while saving the data.
      </v-alert>
    </div>
  </v-container>
</template>
<script>
import DateTimeSelector from "../components/datetimeselector.vue";
import LoaderProgress from "../components/progressLoader";
import jsPDF from "jspdf";
import axios from "axios";
import Breadcrumb from "../components/breadcrumbs.vue";

export default {
  components: {
    DateTimeSelector,
    LoaderProgress,
    Breadcrumb,
  },
  mounted() {
    this.getItAdminApprovedUsers();
    document.querySelector("#errorAlert").style.display = "none";
    document.querySelector("#sucessAlert").style.display = "none";
    this.getITAdminAccessData();
    this.tomorrow();
    this.fromUnixTs =
      Date.parse(new Date().toISOString().substr(0, 10) + " " + "00:00") / 1000;
    this.toUnixTs =
      Date.parse(new Date().toISOString().substr(0, 10) + " " + "00:00") / 1000;
    // this.$refs.form.reset();
  },
  data() {
    return {
      addDisable: false,
      menu: null,
      formTitle: "IT Admin Access Audit",
      dialog: false,
      search: "",
      headersData: [
        {
          text: "Start Date",
          value: "start_date",
          sortable: true,
        },
        {
          text: "End Date",
          value: "end_date",
          sortable: true,
        },
        {
          text: "Reason",
          value: "reason",
          sortable: true,
        },
        {
          text: "Username",
          value: "user_name",
          sortable: true,
        },
        { text: "Actions", value: "actions", sortable: true },
      ],
      inputData: {
        icon: "mdi-account",
        label: "Username",
        itemText: "user_name", // Replace "name" with the field name to display in the dropdown
        itemValue: "id", // Replace "key" with the field name that contains the key (value)
        items: [],
        selectedId: "",
      },
      reason: null,
      paramFrom: {
        defaultTime: new Date().toISOString().substr(0, 10),
        dateLabel: "Start Date",
        timeLable: "Start Time",
        from: true,
        timePicker: true,
      },
      paramTo: {
        defaultTime: new Date().toISOString().substr(0, 10),
        dateLabel: "End Date",
        timeLable: "End Time",
        from: false,
        timePicker: true,
      },
      fromUnixTs: null,
      toUnixTs: null,
      showLoader: false,
      operatorsData: [],
      dataDownload: [],
      isedit: false,
      record_id: null,
    };
  },
  methods: {
    createRecord() {
      this.isedit = false;
    },
    editItem(item) {
      console.log("edierd", item);
      this.isedit = true;
      this.record_id = item.id;
      // window.alert("saikrishna",item)
      console.log(item);
      this.dialog = true;
      // this.addDisable = true
    },

    close() {
      this.dialog = false;
      this.tomorrow();
      this.reason = "";
      // console.log("inside close")
    },
    tomorrow() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate()); //add +1 after testing
      this.paramFrom.defaultTime = tomorrow.toISOString().substr(0, 10);
      this.paramTo.defaultTime = tomorrow.toISOString().substr(0, 10);
    },
    onDatesSelected({ from, date }) {
      if (from) {
        let fromDate = date;
        // console.log("Selected From Date:", fromDate);
        this.fromUnixTs = Date.parse(fromDate) / 1000;
        // console.log("unix ts", this.fromUnixTs);
      } else {
        let toDate = date;
        // console.log("Selected to Date:", toDate);
        this.toUnixTs = Date.parse(toDate) / 1000;
      }
    },

    getITAdminAccessData() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getitadminauditdata`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config).then((response) => {
        this.showLoader = false;
        try {
          console.log("respose of get", response.data);
          this.operatorsData = response.data.data;

          this.showLoader = false;
        } catch (error) {
          this.showLoader = false;
          console.log(error);
        }
      });
    },

    getItAdminApprovedUsers() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getitadminaccessapprovedusers`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config).then((response) => {
        try {
          this.inputData.items = response.data.data;
        } catch (error) {
          this.showLoader = false;
          console.log(error);
        }
      });
    },

    ITadminAccessDataEntry() {
      this.showLoader = true;
      this.dialog = false;
      let config = null;
      let req = null;
      if (!this.isedit) {
        req = {
          startDate: this.fromUnixTs,
          reason: this.reason,
          created_for: this.inputData.selectedId,
        };
        config = {
          method: "post",
          url: `${this.$config.backend_url}/itadminauditdataentry`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: req,
        };
        this.getItAdminApprovedUsers();
      } else {
        req = {
          id: this.record_id,
          endDate: this.toUnixTs,
        };
        config = {
          method: "post",
          url: `${this.$config.backend_url}/updateitadminaudit`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: req,
        };
      }
      console.log("req", req);
      this.noteLastAPICallTime();
      axios(config).then((response) => {
        // console.log("insert respose",response.data);
        if (response.data.status == true) {
          document.querySelector("#sucessAlert").style.display = "block";
          this.getITAdminAccessData();
          this.close();
        } else {
          let message = response.data.message;
          console.log("response messgae", response.data);
          alert(message);
          document.querySelector("#errorAlert").style.display = "block";
          this.showLoader = false;
        }
      });
    },
    createPDF() {
      let content = this.$refs["theDataTable"];
      // console.log("pagination", this.pagination);
      let doc = new jsPDF();
      doc.text(14, 7.5, "Topic Configuration");
      doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimension_separate_again,
        this.$config.second_dimension_separate,
        this.$config.third_dimension_separate,
        this.$config.fourth_dimension_separate_again
      );
      let columnHeaders = [
        "Machine",
        "Device",
        "Topic",
        "Status",
        "Duration(Seconds)",
      ]; // sujan(added duration column)
      let rows = [];
      content.items.forEach((data, index) => {
        if (
          index >= this.pagination.pageStart &&
          index < this.pagination.pageStop
        ) {
          let tempRow = [
            data.machine_name || "",
            data.topic_name || "",
            data.enable_status === "Y" ? "On" : "Off",
            data.duration_value || "", // sujan(added duration column)
            data.device_name || "",
          ];
          rows.push(tempRow);
        }
      });
      doc.setFontSize(9);
      doc.autoTable(columnHeaders, rows, { startY: 11.5 });
      let d = new Date();
      doc.save(
        `Topcis_Management ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`
      );
    },
  },
};
</script>

<style scoped>
#form {
  padding-top: 2%;
}
#container {
  margin-top: 2%;
}
</style>
